import LanguageModal from './languageModal';

export default {
  LanguageModal
};
